export const getLayoutOpts = () => ([
    {
        value: '一室',
        selected: false
    },
    {
        value: '二室',
        selected: false
    },
    {
        value: '三室',
        selected: false
    },
    {
        value: '四室',
        selected: false
    },
    {
        value: '五室',
        selected: false
    },
    {
        value: '五室以上',
        selected: false
    }
])

export const getAreaOpts = () => ([
    {
        text: '70㎡以下',
        value: '0-70',
        selected: false
    },
    {
        text: '70-110㎡',
        value: '70-110',
        selected: false
    },
    {
        text: '110-150㎡',
        value: '110-150',
        selected: false
    },
    {
        text: '150-200㎡',
        value: '150-200',
        selected: false
    },
    {
        text: '200㎡以上',
        value: '200-999999999',
        selected: false
    }
])